<template>
  <div class="dropdown-container">
    <div class="tag-dropdown" @click="show = !show">
      <span>{{ dropdownTitle }}</span>
      <fa-icon :icon="['fa', icon]" />
    </div>
    <div v-if="show" class="dropdown-item-container">
      <div
        @click="setItem(item.id)"
        v-for="item in sortedItems"
        :key="item.id"
        class="item"
      >
        <span class="checkbox">
          <fa-icon
            v-if="selectedItems.includes(item.id)"
            :icon="['fa', 'check']"
          />
        </span>
        <span>{{ item.name }}</span>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  import type { ContentType, Item, Tag, Topic } from "@/types";

  const props = defineProps<{
    dropdownTitle?: string;
    type?: "tag" | "topic" | "content_type";
    items: Item[];
    selectedItems: any[];
  }>();

  const filtersStore = useFiltersStore();
  const dropdownTitle = props.dropdownTitle ?? "Select filter";
  const type = props.type ?? "tag";

  const show = ref(false);

  function toggleDropdown() {
    show.value = !show.value;
  }

  function setItem(id: any) {
    switch (type) {
      case "tag":
        filtersStore.setTag(id as Tag);
        break;
      case "topic":
        filtersStore.setTopic(id as Topic);
        break;
      case "content_type":
        filtersStore.setContentType(id as ContentType);
        break;
    }
  }

  const icon = computed(() => (show.value ? "chevron-down" : "chevron-down"));

  const sortedItems = computed(() =>
    [...props.items]
      .filter(item => item.id)
      .sort((a, b) => {
        if (typeof a.id === "number" && typeof b.id === "number")
          return a.id - b.id;
        return String(a.id).localeCompare(String(b.id));
      })
  );
</script>

<style lang="scss" scoped>
  .dropdown-container {
    margin-bottom: 12px;
  }

  .tag-dropdown {
    width: 100%;
    padding: 16px 12px;
    display: flex;
    justify-content: space-between;
    color: black;
    background: white;
    cursor: pointer;
  }

  .dropdown-item-container {
    width: 100%;
    padding: 0 12px;
    background: white;
    color: black;
    height: 250px;
    overflow-y: scroll;

    .item {
      width: 100%;
      display: flex;
      place-content: center flex-start;
      margin-bottom: 10px;

      .checkbox {
        margin-right: 22px;
        width: 30px;
        height: 30px;
        border: 1px solid black;
        display: flex;
        align-items: center;
        place-content: center center;
        padding: 6px;
        cursor: pointer;
      }
    }
  }
</style>
